import { Injectable } from '@angular/core';

import { AtlasenseapiService } from '../api.service';
import { ConfigurationService } from '../config.service';

import { User } from './user';

const USER_ENDPOINT = 'user';

@Injectable()
export class UserService {

  constructor(
    public api: AtlasenseapiService,
    public config: ConfigurationService) {}

  getUser(user_id: string): User{

    // Mock user
    let user: User = {
      avatar: "assets/avatar.png",
      name: "Anna Atkinson",
      email: "anna@organization.com",
      data_sources: [
        "datasource1",
        "datasource2",
        "datasource3",
        "datasource4",
        "datasource5"
      ],
      role: "owner",
      blocked: true
    }
    return user;
    // let url = this.config.getCanonicalURL() + '/' + USER_ENDPOINT + '/' + user_id;
    // return this.api.get(url);
  }

  getUsers(): User[]{
    // Mock users
    let users: User[] = [
      {
        avatar: "assets/avatar.png",
        name: "Anna Atkinson",
        email: "anna@organization.com",
        data_sources: [
          "datasource1",
          "datasource2",
          "datasource3",
          "datasource4",
          "datasource5"
        ],
        role: "owner",
        blocked: true
      },
      {
        avatar: "assets/avatar.png",
        name: "Brian Carr",
        email: "brian@organization.com",
        data_sources: [
          "datasource1",
          "datasource3",
          "datasource4",
          "datasource5"
        ],
        role: "owner",
        blocked: false
      },
      {
        avatar: "assets/avatar.png",
        name: "Jesse Li",
        email: "jesse@organization.com",
        data_sources: [
          "datasource3",
          "datasource5"
        ],
        role: "collaborator",
        blocked: false
      },
      {
        avatar: "assets/avatar.png",
        name: "Sasha Nikolaev",
        email: "sasha@organization.com",
        data_sources: [],
        role: "reader",
        blocked: false
      }
    ]
    return users;
  }

}
